import { defineComponent } from 'vue';
import AdImage from '@/ad/components/AdImage.vue';
import AdListGallery from '@/ad/components/AdListGallery.vue';
import AdListItemParams from '@/ad/components/AdListItemParams.vue';
import AdListItemPrice from '@/ad/components/AdListItemPrice.vue';
import AdListItemLike from '@/ad/components/AdListItemLike.vue';
import AdListItemFavorite from '@/ad/components/AdListItemFavorite.vue';
import AdListItemCompare from '@/ad/components/AdListItemCompare.vue';
import ResizableImage from '@/shared/components/ResizableImage.vue';
import { googleTagManagerService } from '@/shared/services/GoogleTagManagerService';
import AdLabels from '@/ad/components/AdLabels.vue';
import config from '@/shared/constants/config';

export default defineComponent({
  props: {
    ad: {
      type: Object,
      required: true,
    },
    imageLimitCount: {
      type: Number,
      default: 1,
    },
    isEmailConfirmed: Boolean,
    isPublic: {
      type: Boolean,
      default: true,
    },
    showAgent: {
      type: Boolean,
      default: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AdImage,
    AdListGallery,
    AdListItemParams,
    AdListItemPrice,
    AdListItemLike,
    AdListItemFavorite,
    AdListItemCompare,
    ResizableImage,
    AdLabels,
  },
  data() {
    return {
      isEstateAgencyMode: config.IS_ESTATE_AGENCY_MODE,
    };
  },
  computed: {
    isEstateAgency() {
      return this.ad.estateAgencyId;
    },
    classId(): string {
      return 'estate-listing-' + this.ad.adId + ' ' + this.classByAdType;
    },
    classByAdType(): string {
      switch (this.ad.adType) {
        case 1:
          return 'is-sale';
        case 2:
          return 'is-rent';
        case 3:
          return 'is-roommates';
      }
      return '';
    },
    address(): string {
      let address = '';
      address += this.formatAddressPart(address, '', this.ad.street);
      address += this.formatAddressPart(address, ' ', this.ad.streetNumber);
      address += this.formatAddressPart(address, ', ', this.ad.city);
      return address;
    },
    isSale(): boolean {
      return this.ad.adType === 1;
    },
    isLease(): boolean {
      return this.ad.adType === 2;
    },
    isRoommate(): boolean {
      return this.ad.adType === 3;
    },
    isDeveloperProject(): boolean {
      return this.ad.estateType === 500;
    },
  },
  methods: {
    formatAddressPart(address: string, concatString: string, part: string) {
      if (!address) {
        concatString = '';
      }
      return part ? concatString + part : '';
    },
    onAgentSelect() {
      googleTagManagerService.send({
        event: 'fotorm_click',
      });
    },
    onAgencySelect() {
      googleTagManagerService.send({
        event: 'logora_click',
      });
    },
  },
});
